import { CCSPrimaryQuestionIds } from '../constants/CCSQuestionIds';
import { SurveyQuestionIf, SurveyQuestionIfType } from '../types/Survey.type';

/**
 * Repairs CCS sleep follow-up rules created with the legacy `Sleeping` value.
 * The provocative question has always submitted its canonical option id as `Sleep`.
 */
export const normalizeCCSSleepConditions = (
  conditions: SurveyQuestionIf[] | undefined
): SurveyQuestionIf[] | undefined =>
  conditions?.map(condition =>
    condition.type === SurveyQuestionIfType.equal &&
    condition.id === CCSPrimaryQuestionIds.aggravatesQuestionId &&
    condition.value === 'Sleeping'
      ? { ...condition, value: 'Sleep' }
      : condition
  );
